import { farShared } from "./farTokens.jsx";

/** Shared Dialog styling for FAR modals (light + dark). */
const farDialogStyle = (theme) => {
    const s = farShared(theme);
    const t = s.t;
    return {
        paper: {
            backgroundColor: t.dark ? "#121829" : "#FFFFFF",
            backgroundImage: "none",
            color: t.text,
            borderRadius: "14px",
            border: "1px solid "+t.border,
            width: "100%",
            maxWidth: "640px",
            margin: "16px",
            textAlign: "left"
        },
        wide: { maxWidth: "760px" },
        header: {
            display: "flex",
            alignItems: "flex-start",
            gap: "12px",
            padding: "20px 24px 12px",
            borderBottom: "1px solid "+t.border
        },
        title: { margin: 0, fontSize: "20px", fontWeight: 700, color: t.textStrong, lineHeight: "26px" },
        subtitle: { margin: "4px 0 0", fontSize: "14px", color: t.textMuted, lineHeight: "20px" },
        close: { ...s.ghostIconButton, marginLeft: "auto", flexShrink: 0 },
        body: { padding: "18px 24px", display: "flex", flexDirection: "column", gap: "18px" },
        footer: {
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "flex-end",
            padding: "14px 24px 20px",
            borderTop: "1px solid "+t.border
        },
        section: { display: "flex", flexDirection: "column", gap: "12px" },
        sectionTitle: { margin: 0, fontSize: "13px", fontWeight: 700, letterSpacing: "0.04em", textTransform: "uppercase", color: t.textMuted },
        row: { display: "flex", gap: "12px", alignItems: "flex-end", flexWrap: "wrap" },
        grow: { flex: "1 1 200px", minWidth: 0 },
        field: { display: "flex", flexDirection: "column" },
        label: s.label,
        required: { color: t.danger.fg, marginLeft: "2px" },
        input: s.input,
        inputError: { borderColor: t.danger.solid + " !important" },
        select: { ...s.input, width: "auto", minWidth: "92px", cursor: "pointer", appearance: "auto" },
        textarea: { ...s.input, minHeight: "84px", resize: "vertical", lineHeight: "20px" },
        help: { margin: "6px 0 0", fontSize: "12px", lineHeight: "17px", color: t.textMuted },
        error: { margin: "6px 0 0", fontSize: "12px", lineHeight: "17px", color: t.danger.fg, fontWeight: 600 },
        checkRow: { display: "flex", gap: "18px", flexWrap: "wrap" },
        check: {
            display: "inline-flex", alignItems: "center", gap: "8px", fontSize: "14px", cursor: "pointer", color: t.text,
            "& input": { width: "18px", height: "18px", accentColor: t.accent, cursor: "pointer", margin: 0 }
        },
        primary: s.primaryButton,
        secondary: s.secondaryButton,
        accent: s.accentButton,
        danger: {
            ...s.secondaryButton,
            borderColor: t.danger.solid,
            color: t.danger.fg,
            "&:hover": { backgroundColor: t.danger.bg }
        },
        cancel: {
            ...s.secondaryButton,
            borderColor: t.borderStrong,
            color: t.text,
            "&:hover": { backgroundColor: t.surfaceHover }
        },
        chips: {
            display: "flex", flexWrap: "wrap", gap: "6px", alignItems: "center",
            padding: "6px 8px", minHeight: "42px", borderRadius: "8px", border: "1px solid "+t.borderStrong,
            backgroundColor: t.inputBg, boxSizing: "border-box",
            "&:focus-within": { borderColor: t.focus, boxShadow: "0 0 0 2px "+t.info.bg }
        },
        chip: {
            display: "inline-flex", alignItems: "center", gap: "4px", padding: "2px 4px 2px 10px", borderRadius: "999px",
            backgroundColor: t.surfaceAlt, border: "1px solid "+t.border, fontSize: "13px", color: t.text
        },
        chipRemove: {
            ...s.focusRing,
            display: "inline-flex", alignItems: "center", justifyContent: "center", width: "20px", height: "20px",
            border: "none", borderRadius: "50%", background: "transparent", color: t.textMuted, cursor: "pointer", padding: 0,
            "&:hover": { backgroundColor: t.surfaceHover, color: t.text },
            "& svg": { width: "14px", height: "14px" }
        },
        chipInput: {
            flex: "1 1 160px", minWidth: "120px", border: "none", outline: "none", background: "transparent",
            color: t.text, fontSize: "14px", padding: "6px 4px", fontFamily: "inherit",
            "&::placeholder": { color: t.textMuted, opacity: 1 }
        },
        switchRow: { display: "flex", alignItems: "center", gap: "10px" },
        toggle: {
            ...s.focusRing,
            position: "relative", width: "44px", height: "24px", borderRadius: "999px", border: "none", cursor: "pointer",
            backgroundColor: t.borderStrong, padding: 0, flexShrink: 0, transition: "background-color 0.2s",
            "&::after": {
                content: '""', position: "absolute", top: "3px", left: "3px", width: "18px", height: "18px", borderRadius: "50%",
                backgroundColor: "#FFFFFF", transition: "transform 0.2s"
            },
            "&[aria-checked='true']": { backgroundColor: t.success.solid },
            "&[aria-checked='true']::after": { transform: "translateX(20px)" },
            "&:disabled": { opacity: 0.5, cursor: "not-allowed" }
        },
        muted: { color: t.textMuted }
    };
};

export default farDialogStyle;
